// Send Comment

import { error } from "console";

export const sendFacebookComment = async (commentMessage: string, commentId: string,  onSuccess: () => void) => {
    window.FB.api('/me/accounts', 'GET', {}, (pagesResponse: any) => {
        if (pagesResponse && pagesResponse.data) {
            window.FB.api(
                `/${commentId}/comments`,
                'POST',
                { message: commentMessage, access_token: pagesResponse.data[0].access_token },
                (response: any) => {

                    if (response && !response.error) {
                        console.log('Comment ID:', response.id);
                        onSuccess();
                    } else {
                        console.error('Error:', response.error);
                    }
                }
            );
        }
    });
};

export const sendPrivateMessage = async ( messageText: string, recipientId: string): Promise<void> => {
    let access_token = ""

    await window.FB.api('/me/accounts', 'GET', {}, (pagesResponse: any) => {
    try{        
        if (pagesResponse && pagesResponse.data) {
            access_token = pagesResponse.data[0].access_token
            sendMessage(recipientId, messageText, access_token);
        }
    }
    catch (error:any){
        console.log('failed to fetch access token for sending private message ', error);
    }
    })

};

async function sendMessage(userId:string, messageText:string, access_token:string) {
    console.log(userId)
    const url = `https://graph.facebook.com/v13.0/me/messages?access_token=${access_token}`;
    
    const requestBody = {
        recipient: {
            id: userId
        },
        message: {
            text: messageText
        }
    };

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        });

        const responseData = await response.json();
        
        console.log('Message sent successfully:', responseData);

    } catch (error) {
        console.error('Error sending message:', error);
    }
}